import getHelper from '../../../services/getHelper';

export default getHelper('/user-authentication-schemes/:id');
